import { Controller, type Control } from "react-hook-form";
import { DatePicker, Input } from "antd";
import moment from "moment";
import { ProgramScheduleType } from "../../../../../types/dto/program";

export default function EditProgramScheduleForm({
  control,
  collectionMonthLabel,
}: {
  control: Control<ProgramScheduleType>;
  collectionMonthLabel: string;
}) {
  return (
    <div className="flex flex-col gap-3">
      <div>
        <label>Mes de cobro</label>
        <Input style={{ width: "100%" }} value={collectionMonthLabel} disabled />
      </div>
      <div>
        <label>Fecha límite de pago</label>
        <Controller
          control={control}
          name="day_of_month_payment_limit"
          render={({ field, fieldState }) => (
            <div>
              <DatePicker
                style={{ width: "100%" }}
                value={field.value ? moment(field.value) : null}
                onChange={(date) =>
                  field.onChange(date ? date.format("YYYY-MM-DD") : null)
                }
                format="DD/MM/YYYY"
              />
              {fieldState.error ? (
                <span className="mt-1 block text-xs text-red-500">
                  {fieldState.error.message}
                </span>
              ) : null}
            </div>
          )}
        />
      </div>
      <div>
        <label>Valor a pagar</label>
        <Controller
          control={control}
          name="price"
          render={({ field, fieldState }) => (
            <div>
              <Input
                style={{ width: "100%" }}
                value={field.value ?? ""}
                onChange={(e) => field.onChange(e.target.value)}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
              />
              {fieldState.error ? (
                <span className="mt-1 block text-xs text-red-500">
                  {fieldState.error.message}
                </span>
              ) : null}
            </div>
          )}
        />
      </div>
      <div>
        <label>Valor pronto pago</label>
        <Controller
          control={control}
          name="price_with_prompt_payment_discount"
          render={({ field, fieldState }) => (
            <div>
              <Input
                style={{ width: "100%" }}
                value={field.value ?? ""}
                onChange={(e) => field.onChange(e.target.value)}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
              />
              {fieldState.error ? (
                <span className="mt-1 block text-xs text-red-500">
                  {fieldState.error.message}
                </span>
              ) : null}
            </div>
          )}
        />
      </div>
    </div>
  );
}
